<div [ngClass]="{'product-category': true, 'selected': category.selected}" (click)="clicked()">
  <div class="image">
    <img src="{{category.imageSource}}" />
  </div>
  <div class="label">{{category.name}}</div>
</div>
